import "./src/css/index.css";

// Performance optimizations - lazy load third-party scripts
export const onClientEntry = () => {
  // Preconnect to external domains for faster resource loading
  if (typeof window !== 'undefined') {
    const preconnectDomains = [
      'https://cdn.sanity.io',
      'https://cdn.snipcart.com',
      'https://use.fontawesome.com',
    ];

    preconnectDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = '';
      document.head.appendChild(link);
    });
  }
};

// Delay non-critical third-party scripts
export const onRouteUpdate = () => {
  // This runs on every page change
  // Good place to reinitialize lazy-loaded scripts if needed
};
